<script setup>
  import Layout from "@/layouts/main.vue";
  import PageHeader from "@/components/page-header";
  import '@jobinsjp/vue3-datatable/dist/style.css';
  import { DataTable, TableBody, TableHead, TableBodyCell } from '@jobinsjp/vue3-datatable';
  import moment from 'moment';
  import { truncate } from 'lodash';

  import { computed, ref } from 'vue';
  import { useStore } from 'vuex';

  const store = useStore();
  const lgus = computed(() => store.state.lgu.lgus);
  const pagination = computed(() => store.state.lgu.pagination);
  const title = ref("LGU");
  const items = ref([
    {
      text: "Home",
      href: "/"
    },
    {
      text: "Settings",
    },
    {
      text: "LGU",
      active: true,
    }
  ])

  const loading = computed(() => store.state.globals.loading);

  const query = ref({
    search: ''        
  })

  async function getAllLGUs(dt) {
    await store.dispatch('lgu/getLGUs', {
      page: dt.page,
      pageSize: dt.per_page,
      sortColumn: 'updated_at',
      search: dt.search,
      orderBy: 'desc'
    });
  }

  function formattedDate(date) {
    return moment(date).format('YYYY-MM-DD h:mm A')
  }
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
        <b-overlay :show="loading">
          <div class="d-flex mb-4 justify-content-between">
            <div>
              <h1 class="fs-4 text">LGU</h1>
              <small>Create and edit LGU details</small>
            </div>
            <div>
              <router-link
                    to="/settings/lgu/create"
                    class="btn btn-primary right"
                  >
                  <i class="ri-add-fill label-icon align-middle fs-16 me-2"></i>
                    New LGU
                </router-link>
            </div>
          </div>

        <div class="row">
          <div class="col lg-12">
              <data-table
                  :rows="lgus"
                  :pagination="pagination"
                  striped
                  :loading="loading"
                  :query="query"
                  filter
                  hoverable
                  sortable
                  @loadData="getAllLGUs"
                >

                <template #thead>
                    <table-head>LGU Name</table-head>
                    <table-head>Address</table-head>
                    <table-head>Violation Basic Fee</table-head>
                    <table-head>Code</table-head>
                    <table-head>Token</table-head>
                    <table-head>No Contact Link</table-head>
                    <table-head>Skip OVR</table-head>
                    <table-head>Abbreviation</table-head>
                    <table-head>Date Modified</table-head>
                    <table-head>Action</table-head>
                </template>

                <template #tbody="{row}">
                    <table-body v-text="row.name"/>
                    <table-body :title="truncate(row.address, { length: 20 })" v-text="row.address" />
                    <table-body v-text="`₱ ${parseFloat(row.basic_fee).toFixed(2)}`"/>
                    <table-body v-text="row.code" />
                    <table-body v-text="row.token" />
                    <table-body>
                      <a target="_blank" :href="row.no_contact_link">{{ row.no_contact_link }}</a>
                    </table-body>
                    <table-body>
                      <b-badge :variant="row.skip_ovr ? 'success' : 'warning'">
                        {{ row.skip_ovr ? 'Yes' : 'No' }}
                      </b-badge>
                    </table-body>
                    <table-body v-text="row.abbreviation" />
                    <table-body v-text="formattedDate(row.updated_at)" />
                    <table-body>
                      <router-link
                          :to="`/settings/lgu/${row.id}/view`"
                          class="btn btn-secondary mr-3"
                          title="View"
                        >
                        <i class="mdi mdi-eye label-icon align-middle"></i>
                      </router-link>
                      <router-link
                          :to="`/settings/lgu/${row.id}/edit`"
                          class="btn btn-info"
                          title="Edit"
                        >
                        <i class="ri-pencil-line label-icon align-middle"></i>
                      </router-link>
                    </table-body>
                </template>

                <template #empty>
                  <TableBodyCell colspan="10">
                      No LGU found.
                  </TableBodyCell>
              </template>
            </data-table>
          </div>
        </div>
      </b-overlay>
  </Layout>
</template>